export class BtmReturnReportedProduct {
    private readonly _id: number;
    private readonly _name: string;
    private readonly _quantity: number;
    private readonly _returnReason: string;

    constructor(id: number, name: string, quantity: number, returnReason: string) {
        this._id = id;
        this._name = name;
        this._quantity = quantity;
        this._returnReason = returnReason;
    }

    get id(): number {
        return this._id;
    }

    get name() {
        return this._name;
    }

    get quantity() {
        return this._quantity;
    }

    get returnReason() {
        return this._returnReason;
    }
}
